import React, {useState, FC} from 'react';
import {Button, Modal, Radio} from 'uikit';
import CalendarIcon from '@/assets/images/modals/calendar.svg';
import CrossIcon from '@/assets/images/icons/24/close.svg';
import './CreateEntityModal.scss';
import {CreateEntityModalProps} from "@/views/Admin/Layout/CreateEntityModal/CreateEntityModal.props.interface";

const CreateEntityModal: FC<CreateEntityModalProps> = ({showCreateModal, setShowCreateModal}) => {
    const [isEvent, setIsEvent] = useState<boolean>(true);

    const handleCreate = (): void => {
        const path = isEvent ? '/admin/events/create/' : '/admin/courses/create/';
        window.location.replace(path);
    };

    return (
        <Modal
            active={showCreateModal}
            onActive={setShowCreateModal}
            onMissClick={() => setShowCreateModal(false)}
            onEscape={() => setShowCreateModal(false)}
            style={{padding: '20px', maxWidth: '400px', width: '100%'}}
            data-testid="create-modal"
        >
            <div className="create-entity">
                <button
                    className="create-entity__close"
                    onClick={() => setShowCreateModal(false)}
                    aria-label="Закрыть"
                    data-testid="modal-close-button"
                >
                    <CrossIcon/>
                </button>

                <div className="create-entity__header">
                    <div className="create-entity__icon">
                        <CalendarIcon/>
                    </div>
                    <h3 className="create-entity__title">Создать</h3>
                </div>

                <div className="create-entity__options">
                    <div
                        className={`create-entity__option ${isEvent ? 'create-entity__option--active' : ''}`}
                        onClick={() => setIsEvent(true)}
                        data-testid="radio-event"
                    >
                        <Radio
                            size="medium"
                            checked={isEvent}
                            onChange={() => setIsEvent(true)}
                        />
                        <span>Событие</span>
                    </div>
                    <div
                        className={`create-entity__option ${!isEvent ? 'create-entity__option--active' : ''}`}
                        onClick={() => setIsEvent(false)}
                        data-testid="radio-course"
                    >
                        <Radio
                            size="medium"
                            checked={!isEvent}
                            onChange={() => setIsEvent(false)}
                        />
                        <span>Курс</span>
                    </div>
                </div>

                <div className="create-entity__footer">
                    <Button
                        size={"large"}
                        type={"events"}
                        theme={"default"}
                        onClick={handleCreate}
                        data-testid="continue-create"
                    >
                    Продолжить
                    </Button>
                </div>
            </div>
        </Modal>
    )
}

export default CreateEntityModal;
